// extracted by mini-css-extract-plugin
export default {"host":"style_host__0p0Jj","projectPanel":"style_projectPanel__hqTdU","content":"style_content__lcU4Y","approvals":"style_approvals__lFR7L"};